export default "__VITE_ASSET__DcgjZW17__"